import "./style.css";
import { FC } from "react";
export const Skeleton: FC<{ isShow: boolean }> = ({ isShow }) => {
  if (!isShow) return <></>;

  return <div className="skeleton"></div>;
};
